


















import { BasicStrengthDTO } from '../../../src_server/entity/dto/BasicStrengthDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { basicStrengthAllData, basicStrengthTitle, getItemOptions, getItemOptionsByName } from '../../../src_server/entity/master/basicStrengthData';

@Component({
  components: {},
  filters: {
    basicStrengthTitle: (item: string) => {
      return basicStrengthTitle[item];
    },
  },
})
export default class BasicStrenghtRow extends Vue {
  @Prop({ default: new BasicStrengthDTO() })
  private value!: BasicStrengthDTO;

  get model() {
    return this.value;
  }

  get rowCss() {
    return this.value.disabled ? ['clr-gray'] : ['clr-blk'];
  }

  get levelOptions() {
    return getItemOptions(this.value.strength_item!);
  }

  setLevel(current_level: number, st: BasicStrengthDTO) {
    this.value.current_level = current_level;
    this.value.score = current_level * 8;
    this.$emit('input', this.value);
  }

  selectedDisabled(event: Event) {
    const check = event.target as any;
    this.value.disabled = check.checked;
    this.$emit('input', this.value);
  }
}
